import { alpha } from '@mui/material';

export const glassSurface = (theme, intensity = 'medium') => {
	const isDark = theme.palette.mode === 'dark';
	const blur = intensity === 'strong' ? 48 : intensity === 'medium' ? 32 : 20;
	const bgAlpha = isDark ? 0.55 : 0.72;

	return {
		background: isDark
			? alpha('#1C1C1E', bgAlpha)
			: alpha('#FFFFFF', bgAlpha),
		backdropFilter: `blur(${blur}px) saturate(180%)`,
		WebkitBackdropFilter: `blur(${blur}px) saturate(180%)`,
		border: '1px solid',
		borderColor: isDark
			? alpha('#FFFFFF', 0.1)
			: alpha('#FFFFFF', 0.65),
		boxShadow: isDark
			? `0 8px 32px ${alpha('#000000', 0.45)}, inset 0 1px 0 ${alpha('#FFFFFF', 0.06)}`
			: `0 8px 32px ${alpha('#000000', 0.08)}, 0 2px 8px ${alpha('#000000', 0.04)}, inset 0 1px 0 ${alpha('#FFFFFF', 0.9)}`,
	};
};

export const glassPill = (theme, active = false) => {
	const isDark = theme.palette.mode === 'dark';

	if (active) {
		return {
			background: isDark
				? alpha(theme.palette.primary.main, 0.22)
				: alpha(theme.palette.primary.main, 0.12),
			backdropFilter: 'blur(12px)',
			WebkitBackdropFilter: 'blur(12px)',
			border: '1px solid',
			borderColor: alpha(theme.palette.primary.main, isDark ? 0.35 : 0.2),
			boxShadow: isDark
				? `0 0 20px ${alpha(theme.palette.primary.main, 0.15)}`
				: `0 2px 12px ${alpha(theme.palette.primary.main, 0.12)}`,
		};
	}

	return {
		background: 'transparent',
		border: '1px solid transparent',
		'&:hover': {
			background: isDark
				? alpha('#FFFFFF', 0.06)
				: alpha('#000000', 0.04),
		},
	};
};
